
// Service to handle anonymous user sessions and data
export class AnonymousUserService {
  private static SESSION_KEY = 'anonymous_session_id';
  private static STORAGE_PREFIX = 'anonymous_prayers_';

  // Generate or retrieve anonymous session ID
  static getSessionId(): string {
    let sessionId = sessionStorage.getItem(this.SESSION_KEY);
    if (!sessionId) {
      sessionId = crypto.randomUUID();
      sessionStorage.setItem(this.SESSION_KEY, sessionId);
    }
    return sessionId;
  }

  // Store prayer request for anonymous user
  static storePrayerRequest(request: any): void {
    const sessionId = this.getSessionId();
    const key = `${this.STORAGE_PREFIX}${sessionId}`;
    const existingRequests = this.getPrayerRequests();
    const updatedRequests = [...existingRequests, { ...request, sessionId, timestamp: Date.now() }];
    localStorage.setItem(key, JSON.stringify(updatedRequests));
  }

  // Get prayer requests for anonymous user
  static getPrayerRequests(): any[] {
    const sessionId = this.getSessionId();
    const key = `${this.STORAGE_PREFIX}${sessionId}`;
    const stored = localStorage.getItem(key);
    return stored ? JSON.parse(stored) : [];
  }

  // Clear anonymous data (used when user signs up)
  static clearAnonymousData(): void {
    const sessionId = sessionStorage.getItem(this.SESSION_KEY);
    if (sessionId) {
      const key = `${this.STORAGE_PREFIX}${sessionId}`;
      localStorage.removeItem(key);
      sessionStorage.removeItem(this.SESSION_KEY);
    }
  }

  // Check if user has anonymous prayer data
  static hasAnonymousData(): boolean {
    return this.getPrayerRequests().length > 0;
  }
}
